/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab.ts";
import { courseRegistrationManagementHistoryItemViewModelSchema } from "../courseRegistrationManagementHistoryItemViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementHistoryItemViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse>;
